// extracted by mini-css-extract-plugin
export default {"container":"TechnicalError_container__RtsX8","loading":"TechnicalError_loading__bQ+Hb"};